/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 * See: https://github.com/zloirock/core-js#babel
 */
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// Added for auth0-lock to work
;(window as any).global = window

// Safari 13 arrayBuffer polyfill
;(function () {
  function promisify<T>(obj): Promise<T> {
    return new Promise(function (resolve, reject) {
      obj.onload = obj.onerror = function (evt) {
        obj.onload = obj.onerror = null

        evt.type === 'load'
          ? resolve((obj.result as T) || obj)
          : reject(new Error('Failed to read the blob/file'))
      }
    })
  }

  if ('File' in window) {
    File.prototype.arrayBuffer = File.prototype.arrayBuffer || myArrayBuffer
  }
  Blob.prototype.arrayBuffer = Blob.prototype.arrayBuffer || myArrayBuffer

  function myArrayBuffer(): Promise<ArrayBuffer> {
    const fr = new FileReader()
    fr.readAsArrayBuffer(this)
    return promisify<ArrayBuffer>(fr)
  }
})()
